/* eslint-disable */
export default {
  forward: 'Forward',
  cancel: 'Cancel',
  customNumber: 'Custom number',
} as const;

// @key: @#@"forward"@#@ @source: @#@"Forward"@#@
// @key: @#@"cancel"@#@ @source: @#@"Cancel"@#@
// @key: @#@"customNumber"@#@ @source: @#@"Custom number"@#@
